const React = require('react');
const {AdminFormRow, AdminFormCol, AdminSubtitle} = require('../../../AdminLayout');
const {AdminInput, AdminSelect, AdminSelectCountry, AdminSwitch, AdminDocumentUploadOnboarding} = require('../../../../FormInputs');

const DocumentsBlockTitle = require('../DocumentsBlockTitle');
const {apiV2KycDocumentUpload} = require("../../../../../../api/admin/retailersCreate");

const ThreeColumnsRow = (props) => <AdminFormRow {...props} className="mh-15-i" />;
const ThreeColumnsCols = (props) => <AdminFormCol {...props} className="wmax1/3-i ph15-i" />;

const AddressFields = ({prefix, formCtx, disabled}) => {
  const setId = (name) => `${prefix}_${name}`;
  return (
    <>
      <ThreeColumnsRow>
        <ThreeColumnsCols>
          <AdminInput
            name={setId('street')}
            label="Business Address ( Street and house № )"
            formCtx={formCtx}
            disabled={disabled}
          />
        </ThreeColumnsCols>
        <ThreeColumnsCols>
          <AdminInput
            name={setId('address')}
            label="Address Line 2"
            formCtx={formCtx}
            disabled={disabled}
          />
        </ThreeColumnsCols>
        <ThreeColumnsCols>
          <AdminInput
            name={setId('zip')}
            label="Zip / Postal code"
            formCtx={formCtx}
            disabled={disabled}
          />
        </ThreeColumnsCols>
      </ThreeColumnsRow>
      <AdminFormRow>
        <AdminFormCol>
          <AdminInput
            name={setId('city')}
            label="City"
            formCtx={formCtx}
            disabled={disabled}
          />
        </AdminFormCol>
        <AdminFormCol>
          <AdminSelectCountry
            name={setId('country')}
            label="Country"
            formCtx={formCtx}
            disabled={disabled}
          />
        </AdminFormCol>
      </AdminFormRow>
    </>
  )
}

module.exports = ({account_id, formCtx}) => {
  const data = (formCtx.state || {}).data || {};
  const operatingIsEqual = data.operating_equals_business;
  return (
    <>
      <ThreeColumnsRow>
        <ThreeColumnsCols>
          <AdminInput
            name="company_name"
            label="Legal Company Name"
            formCtx={formCtx}
          />
        </ThreeColumnsCols>
        <ThreeColumnsCols>
          <AdminInput
            name="reg_number"
            label="Business Registration Number"
            formCtx={formCtx}
          />
        </ThreeColumnsCols>
        <ThreeColumnsCols>
          <AdminSelect
            name="nature"
            label="Nature of business"
            // propName="0"
            // propValue="1"
            items={['General', 'Gambling']}
            formCtx={formCtx}
          />
        </ThreeColumnsCols>
      </ThreeColumnsRow>
      <AddressFields
        prefix="register"
        formCtx={formCtx}
      />
      <div className="layoutRow jcSB aiC mt30">
        <AdminSubtitle text="Operating address" />
        <AdminSwitch
          label="Same As Business Address"
          value={operatingIsEqual}
          onChange={() => {
            formCtx.onManualChange(!operatingIsEqual ? {
              operating_equals_business: true
            } : {
              operating_equals_business: false
            })
          }}
        />
      </div>
      <div className="mt27">
        <AddressFields
          prefix={operatingIsEqual ? 'register' : 'operating'}
          formCtx={formCtx}
          disabled={operatingIsEqual}
        />
      </div>
      <div className="mt27">
        <DocumentsBlockTitle />
        <AdminFormRow>
          <AdminFormCol>
            <AdminDocumentUploadOnboarding
              name="business_registration_extract"
              textProps={{
                title: 'Business registration extract',
                desc: 'Business registration extract provided by country of registration',
              }}
              apiUpload={(params) => {
                const doc_meta = {account_id};
                return apiV2KycDocumentUpload({...params, doc_meta});
              }}
              formCtx={formCtx}
            />
          </AdminFormCol>
          <AdminFormCol>
            <AdminDocumentUploadOnboarding
              name="business_operating_address"
              textProps={{
                title: 'Proof of Business operating address',
                desc: 'A document, such as a bank statement or utility bill, dated within the last 3 months and containing the business name and operating address.',
              }}
              apiUpload={(params) => {
                const doc_meta = {account_id};
                return apiV2KycDocumentUpload({...params, doc_meta});
              }}
              formCtx={formCtx}
            />
          </AdminFormCol>
          <AdminFormCol>
            <AdminDocumentUploadOnboarding
              name="share_holder_structure"
              textProps={{
                title: 'Proof of Shareholder structure',
                desc: 'Latest official document confirming the names of all directors, UBOs/shareholders (holding more than 20%), and other individuals with significant control.',
              }}
              apiUpload={(params) => {
                const doc_meta = {account_id};
                return apiV2KycDocumentUpload({...params, doc_meta});
              }}
              formCtx={formCtx}
            />
          </AdminFormCol>
        </AdminFormRow>
      </div>



      {/*<div className="mt30">*/}
      {/*  <AdminSubtitle text="Please provide us with supporting documents" />*/}
      {/*  <p className="mv18 f12 lh18">*/}
      {/*    We need this documents to open your account with us.<br/>*/}
      {/*    Accepted types - PDF, Scanned copy, Clear photo JGEG, JPG, PNG and not more than 5 MB each document.*/}
      {/*  </p>*/}
      {/*</div>*/}
    </>
  )
}
